const publicRoutes = [
  { path: "/", includeInSitemap: true },
  { path: "/statuto", includeInSitemap: true },
  { path: "/regolamento", includeInSitemap: true },
  { path: "/advisory-board", includeInSitemap: true },
  { path: "/contatti", includeInSitemap: true },
  { path: "/login", includeInSitemap: true },
  { path: "/evento/:token", includeInSitemap: false },
  { path: "/evento/:token/conferma", includeInSitemap: false },
  { path: "/evento/:token/registra", includeInSitemap: false },
  { path: "/payment/activity/:activityId", includeInSitemap: false },
  { path: "/payment-success", includeInSitemap: false },
  { path: "/cookie-policy", includeInSitemap: true },
  { path: "/privacy-policy", includeInSitemap: true },
];

module.exports = publicRoutes;
module.exports.default = publicRoutes;
